import React from "react";
import { withRouter } from "react-router-dom";
import logger from "../../../utils/LoggerFrontend";
import { AdAssistantLayout } from "../AdAssistant.styled";
import { ActionsWrapper, Header } from "../edition-modal/EditionModal.styled";
import { EmptyButton } from "../overview/AdAssistantOverview.styled";
import { ArrowLeftIcon } from "../../../Components/Icons";
import AdAssistantStore from "../AdAssistantStore";
import { withRefluxStore } from "../../../Stores";
import AdAssistantBookingOverview from "./AdAssistantBookingOverview";

import { channels } from "../../../data/app__channels";
import packageseDRSP from "../../../data/app__packages--DRSP.js";
import packagesAWSMembers from "../../../data/app__packages--aws-personalmarketing-members.js";
import packagesAWS from "../../../data/app__packages--aws-personalmarketing.js";
import packageseEmplify from "../../../data/app__packages--emplify.js";
import packagesPhrase from "../../../data/app__packages--phrase.js";
import packagesScheerer from "../../../data/app__packages--scheerer.js";
import packageseYield from "../../../data/app__packages--yield.js";

const allAWSPackages = packagesAWS.concat(packagesAWSMembers);

const AdAssistantCheckout = ({ match, history, campaignData, organization }) => {
  const { campaignId } = match.params;

  const dataInformed = organization && campaignData && Object.keys(campaignData).length > 0;

  const getSelectedChannelsList = (packageId = "newBooking", lifeTimeBudget, selectedChannels) => {
    logger.debug("CampaignCreate:getSelectedChannelsList", "NEW called...", {
      selectedChannels,
      lifeTimeBudget,
      packageId
    });

    const selectedChannel = [...selectedChannels];

    if (
      packageId.includes("individuell") ||
      packageId.includes("std--") ||
      packageId.includes("jap-feed")
    ) {
      selectedChannel.push(channels.find((channel) => channel.channel_short_name === "facebook"));
      selectedChannel.push(channels.find((channel) => channel.channel_short_name === "instagram"));

      if (lifeTimeBudget >= 800) {
        selectedChannel.push(
          channels.find((channel) => channel.channel_short_name === "google-display")
        );
      }
      return removeDuplicatesBy(selectedChannel, "channel_short_name");
    }

    if (packageId.includes("scheerer")) {
      return packagesScheerer.find((pkg) => pkg.id === packageId).selectedChannels;
    }

    if (packageId.includes("phrase")) {
      return packagesPhrase.find((pkg) => pkg.id === packageId).selectedChannels;
    }

    if (packageId.includes("aws")) {
      return allAWSPackages.find((pkg) => pkg.id === packageId).selectedChannels;
    }

    if (packageId.includes("emplify")) {
      return packageseEmplify.find((pkg) => pkg.id === packageId).selectedChannels;
    }

    if (packageId.includes("drsp")) {
      return packageseDRSP.find((pkg) => pkg.id === packageId).selectedChannels;
    }

    if (packageId.includes("yield")) {
      return packageseYield.find((pkg) => pkg.id === packageId).selectedChannels;
    }

    logger.debug("CampaignCreate:getSelectedChannelsList", "called...", {
      selectedChannel,
      lifeTimeBudget
    });

    return selectedChannel;
  };

  // Helper function to remove duplicates by a specific property
  const removeDuplicatesBy = (array, key) => {
    const seen = new Set();
    return array.filter((item) => {
      const value = item[key];
      if (seen.has(value)) {
        return false;
      }
      seen.add(value);
      return true;
    });
  };

  return (
    <AdAssistantLayout>
      <Header>
        <ActionsWrapper>
          <EmptyButton
            onClick={() => history.push(`/assistant/budget-check/${campaignId}?budgetCheck=false`)}
          >
            <ArrowLeftIcon />
          </EmptyButton>
        </ActionsWrapper>
      </Header>

      {dataInformed && (
        <AdAssistantBookingOverview
          {...campaignData}
          organization={organization}
          orgaId={campaignData?.organizationId}
          location={campaignData?.locations}
          campaignDuration={campaignData?.duration || 30}
          campaignId={campaignId}
          selectedChannelList={getSelectedChannelsList(
            campaignData?.packageId,
            campaignData?.lifeTimeBudget,
            campaignData?.selectedChannels
          )}
          history={history}
        />
      )}
    </AdAssistantLayout>
  );
};
export default withRouter(
  withRefluxStore(
    AdAssistantCheckout,
    [AdAssistantStore],
    ["campaignData", "organization", "userProfile"]
  )
);
